<template>
  <div>
    <TwTable
      :searchData="searchData"
      :buttonList="buttonList"
      :tableData="tableData"
      :tableConfig="tableConfig"
      @resetBtn="resetBtn"
      :pageConfig="pageConfig"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:status>
        <el-select
          multiple
          v-model="filters.status"
          placeholder="请选择状态"
          collapse-tags
        >
          <el-option
            v-for="item in statuslist"
            :label="item.stockingStatusText"
            :value="item.stockingStatusId"
            :key="item.stockingStatusId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:wareHouse>
        <el-select
          multiple
          filterable
          v-model="filters.wareHouse"
          placeholder="请选择发货仓"
          collapse-tags
        >
          <el-option
            v-for="item in warehouseList"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:transport>
        <el-select
          multiple
          v-model="filters.transport"
          placeholder="请选择运输方式"
          collapse-tags
        >
          <el-option
            v-for="item in transportList"
            :label="item.transportTypeText"
            :value="item.transportTypeText"
            :key="item.transportTypeText"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:packingStatus>
        <el-select
          multiple
          v-model="filters.packingStatus"
          placeholder="请选择装箱状态"
          collapse-tags
        >
          <el-option
            v-for="item in packingStatusList"
            :label="item.packingStatusText"
            :value="item.packingStatusId"
            :key="item.packingStatusId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:loadingType>
        <el-select
          multiple
          v-model="filters.loadingType"
          placeholder="请选择装车状态"
          collapse-tags
        >
          <el-option
            v-for="item in loadingTypeList"
            :label="item.loadingTypeText"
            :value="item.loadingTypeId"
            :key="item.loadingTypeId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:dataSourceType>
        <el-select
          multiple
          v-model="filters.dataSourceType"
          placeholder="请选择数据来源"
          collapse-tags
        >
          <el-option
            v-for="item in dataSourceTypeList"
            :label="item.dataSourceTypeText"
            :value="item.dataSourceTypeId"
            :key="item.dataSourceTypeId"
          ></el-option>
        </el-select>
      </template>

      <template slot-scope="scope" slot="stockingNo">
        <span
          >备货号:<el-link
            :underline="false"
            type="primary"
            @click.native="addBoxMark(scope.row.stockingTaskID)"
            >{{ scope.row.stockingNo }}
          </el-link></span
        ><br />
        <span>封条号:{{ scope.row.sealNumber }}</span
        ><br />
        <span>SO号:{{ scope.row.soNumber }}</span
        ><br />
        <span>柜号:{{ scope.row.containerNumber }}</span
        ><br />
      </template>
      <template slot-scope="scope" slot="containerNo">
        <span>货柜号:{{ scope.row.containerNo }}</span
        ><br />
        <span
          >调拨单号:
          <el-link
            :underline="false"
            type="primary"
            @click.native="getBoxMarkTransfer(scope.row.stockingTaskID)"
            >{{ scope.row.stockTransferNo }}
          </el-link>
        </span>
        <br />
        <span
          >装车单号:
          {{ scope.row.loadCarNo }}
        </span>
        <br />
        <span
          >数据来源:
          {{ scope.row.dataSourceTypeDesc }}
        </span>
        <br />
      </template>
      <template slot-scope="scope" slot="bookingspace">
        <div v-if="scope.row.transportType == '海运'">
          <span>封条号:{{ scope.row.sealNumber }}</span
          ><br />
          <span>SO号:{{ scope.row.soNumber }}</span
          ><br />
          <span>柜号:{{ scope.row.containerNumber }}</span
          ><br />
        </div>
        <div v-if="scope.row.transportType == '空运'">
          <span>航空单号:{{ scope.row.waybillNumber }}</span
          ><br />
        </div>

        <div v-if="scope.row.transportType == '快递'">
          <span>追踪单号:{{ scope.row.trackingNumber }}</span
          ><br />
        </div>
      </template>

      <template slot-scope="scope" slot="file">
        <div>
          <span>打包照片:</span>
          <span v-if="scope.row.isUploadPackPic == true">
            <el-link
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.stockingTaskID, 1)"
            >
              预览
            </el-link>
            <el-link
              style="margin-left: 5px"
              :underline="false"
              type="primary"
              @click.native="handleImages(scope.row.stockingTaskID, 1)"
            >
              下载
            </el-link>
          </span>
          <br />
          <span>备柜照片:</span>
          <span v-if="scope.row.isUploadBoxMarkPic == true">
            <el-link
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.stockingTaskID, 2)"
            >
              预览
            </el-link>
            <el-link
              style="margin-left: 5px"
              :underline="false"
              type="primary"
              @click.native="handleImages(scope.row.stockingTaskID, 2)"
            >
              下载
            </el-link>
          </span>
          <br />
          <span>装车照片:</span>
          <span v-if="scope.row.isUploadCarPic == true">
            <el-link
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.stockingTaskID, 3)"
            >
              预览
            </el-link>
            <el-link
              style="margin-left: 5px"
              :underline="false"
              type="primary"
              @click.native="handleImages(scope.row.stockingTaskID, 3)"
            >
              下载
            </el-link>
          </span>
          <br />
        </div>
      </template>
      <template slot-scope="scope" slot="operatorInfo">
          <span>拣货:{{ scope.row.pickUser }}</span>
          <br />
          <span>打包:{{ scope.row.packUser }}</span>
          <br />
          <span>装车:{{ scope.row.loadUser }}</span>
      </template>
      <template v-slot:realName>
        <el-select multiple v-model="filters.realName" filterable placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>
    </TwTable>
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 13, businessCode: currentRow.stockingNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>

    <el-dialog
      title="备货单详情"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      :visible.sync="visibledialogDetail"
      v-model="visibledialogDetail"
      width="80%"
      center
    >
      <el-form :model="DetailForm">
        <el-card shadow="hover" style="margin-top: 10px; width: 100%">
          <div slot="header" class="clearfix">
            <span>备货信息</span>
          </div>

          <el-row>
            <el-col :span="8">
              <el-form-item label="备货单：" style="margin-bottom: 0"
                >{{ DetailForm.stockingNo }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="仓库：" style="margin-bottom: 0">
                {{ DetailForm.warehouseCode }}({{ DetailForm.warehouseName }})
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="调入仓：" style="margin-bottom: 0">
                {{ DetailForm.physicalWarehouse }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="状态：" style="margin-bottom: 0">
                {{ DetailForm.stockingStatusText }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="柜号：" style="margin-bottom: 0">
                {{ DetailForm.containerNumber }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="货柜号：" style="margin-bottom: 0">
                {{ DetailForm.containerNo }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="推送时间：" style="margin-bottom: 0">
                {{ DetailForm.createTime }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车牌号：" style="margin-bottom: 0">
                {{ DetailForm.carNumber }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="调拨单号：" style="margin-bottom: 0">
                {{ DetailForm.stockTransferNo }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="拣货时间：" style="margin-bottom: 0">
                {{ DetailForm.pickTime }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人：" style="margin-bottom: 0">
                {{ DetailForm.contactUser }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="调拨数量：" style="margin-bottom: 0">
                {{ DetailForm.qty }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="出库时间：" style="margin-bottom: 0">
                {{ DetailForm.outTime }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="运输方式：" style="margin-bottom: 0">
                {{ DetailForm.transportType }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出库数量：" style="margin-bottom: 0">
                {{ DetailForm.quantity }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <el-card shadow="hover" style="margin-top: 10px; width: 100%">
          <div slot="header" class="clearfix">
            <span>SKU信息</span>
          </div>

          <el-table
            :data="plantabledata"
            highlight-current-row
            border
            style="width: 100%;heiht"
          >
            <el-table-column prop="shippingNo" min-width="120" label="出库计划">
            </el-table-column>

            <el-table-column prop="sku" label="SKU"> </el-table-column>
            <el-table-column
              prop="productNameCN"
              label="SKU名称"
              min-width="180"
            >
            </el-table-column>
            <el-table-column prop="brand" label="品牌"> </el-table-column>
            <el-table-column prop="model" label="型号"> </el-table-column>
            <el-table-column prop="customName" label="供应商">
            </el-table-column>
            <el-table-column prop="isElectricityText" label="带电发货">
            </el-table-column>
            <el-table-column label="条码方式">
              <template slot-scope="scope">
                {{
                  scope.row.warehouseLable == 0
                    ? ""
                    : scope.row.warehouseLable == 1
                    ? "货主贴"
                    : "仓库贴"
                }}
                <br />
              </template>
            </el-table-column>
            <el-table-column label="FBA信息" min-width="140">
              <template slot-scope="scope">
                FNSKU： {{ scope.row.fnsku }} <br />
                SHIPMENTID: {{ scope.row.shipmentID }}<br />
                箱唛条码：{{ scope.row.boxMark }}
              </template>
            </el-table-column>
            <el-table-column prop="fbaWarehouseCode" label="FBA代码">
            </el-table-column>
            <el-table-column prop="quantity" label="调拨数量">
            </el-table-column>
          </el-table>
        </el-card>
        <el-card shadow="hover" style="margin-top: 10px; width: 100%">
          <div slot="header" class="clearfix">
            <span>装箱信息</span>
          </div>

          <el-table
            :data="boxtabledata"
            highlight-current-row
            border
            style="width: 100%"
          >
            <el-table-column prop="boxNo" label="箱号">
              <template slot-scope="scope">
                <span v-if="scope.row.boxNo > 0">
                  {{ scope.row.boxNo }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="wmsBoxNo" width="150" label="WMS箱唛">
            </el-table-column>
            <el-table-column prop="destinationBoxNo" width="120" label="箱唛">
            </el-table-column>
            <el-table-column prop="shippingNo" label="出库计划">
            </el-table-column>
            <el-table-column prop="sku" label="SKU"> </el-table-column>
            <el-table-column
              prop="productNameCN"
              label="SKU名称"
              min-width="180"
            ></el-table-column>
            <el-table-column prop="BoxLength" label="尺寸(cm)">
              <template slot-scope="scope">
                {{ scope.row.boxLength }}*{{ scope.row.boxWidth }}*{{
                  scope.row.boxHeight
                }}
              </template>
            </el-table-column>
            <el-table-column prop="volume" label="体积(cbm)"> </el-table-column>
            <el-table-column prop="boxWeight" label="毛重(kg)">
            </el-table-column>
            <el-table-column prop="qty" label="数量"> </el-table-column>
            <el-table-column prop="boxTypeText" label="类型"> </el-table-column>
            <el-table-column prop="statusText" label="状态"> </el-table-column>
          </el-table>
        </el-card>
      </el-form>
    </el-dialog>

    <!-- 打包 -->
    <el-dialog
      :visible.sync="importVisible"
      v-model="importVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="上传装箱信息"
      width="40%"
      style="text-align: center"
    >
      <el-form>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              ref="upload"
              class="upload-demo"
              drag
              action="string"
              :http-request="UploadExcel"
              :limit="1"
              accept=".xls,.xlsx"
              :before-upload="onBeforeUploadExcel"
              :auto-upload="false"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传.xls,.xlsx文件
              </div>
            </el-upload>
          </el-form-item>
        </el-row>
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
            <el-button type="primary" @click="handleDownload()"
              >下载打包数据</el-button
            >
          </el-form-item>
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="submitUpload"
              >上传装箱信息</el-button
            >
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <span style="color: red"> {{ Importtext }}</span>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 预览图片 -->

    <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
      <img v-for="(src, index) in srcList" :src="src" :key="index" />
    </viewer>

    <el-dialog
      :visible.sync="boxMarkVisible"
      v-model="boxMarkVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="箱唛文件"
      width="60%"
      style="text-align: center"
    >
      <el-table
        :data="transferdata"
        highlight-current-row
        border
        style="width: 100%;heiht"
        @row-click="handleRowClick"
      >
        <el-table-column prop="stockingNo" label="备货单号"> </el-table-column>
        <el-table-column prop="transferNo" label="调拨单号"> </el-table-column>
        <el-table-column prop="carrierName" label="承运商" min-width="160">
        </el-table-column>
        <el-table-column
          prop="warehouseName"
          label="线路入库仓"
          min-width="160"
        >
        </el-table-column>
        <el-table-column label="箱唛文件">
          <template slot-scope="scope">
            <span v-if="scope.row.uploadFileInfoID > 0">
              <el-link
                :underline="false"
                type="primary"
                @click.native="DownloadProductSKUAttachBtn(scope.row.imgurls)"
              >
                下载
              </el-link>
            </span>
            <!-- @click.native="
                  DownloadProductSKUAttachBtn(
                    scope.row.fileUrl,
                    scope.row.fileName,
                    scope.row.uploadType
                  )
                " -->
            <br />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <!-- <el-link
              :underline="false"
              type="primary"
              @click.native="addReadyImages()"
            >
              点击上传
            </el-link> -->
            <el-link
              :underline="false"
              type="success"
              @click.native="
                printMark(scope.row.stockingTaskID, scope.row.fileUrl)
              "
              v-if="scope.row.uploadFileInfoID > 0"
              >打印</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 上传箱唛文件 -->
    <el-dialog
      :visible.sync="importPicture"
      v-model="importPicture"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="上传箱唛文件"
      width="40%"
      style="text-align: center"
    >
      <el-form>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              class="upload-demo"
              action="string"
              multiple
              accept=".pdf"
              :limit="10"
              drag
              :file-list="fileList"
              :before-remove="beforeRemove"
              :on-change="onChange"
              :http-request="httpRequest"
              :on-remove="onRemove"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">只能上传PDF文件</div>
            </el-upload>
          </el-form-item>
        </el-row>
        <!-- :http-request="UploadBoxMarkExcel" -->
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <!-- <el-form-item>
            <el-button type="primary" @click="handleDownload()"
              >下载打包数据</el-button
            >
          </el-form-item> -->
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="UploadBoxMarkExcel"
              >上传箱唛文件</el-button
            >
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 附件管理 -->
    <el-dialog
      title="附件管理"
      :visible.sync="attachFormVisible"
      :before-close="handleClose"
    >
      <el-form :model="attachForm" label-width="80px" ref="attachForm">
        <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item label="附件类型" prop="attachType">
            <el-select v-model="attachForm.attachType" @change="selectAttach">
              <el-option
                v-for="item in options_attachType"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>

        <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              ref="refupload"
              class="upload-demo"
              drag
              action="string"
              :file-list="fileListAttach"
              :before-upload="onBeforeUpload"
              :on-change="onChangeAttach"
              :on-remove="onAttachRemove"
              :multiple="multipleAttach"
              :accept="acceptAttach"
              :auto-upload="false"
              :http-request="auploadFile"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">
                只能上传.xls,.xlsx文件
              </div> -->
            </el-upload>

            <el-button
              type="primary"
              @click="UploadAttach"
              :loading="fileLoading"
              >{{ fileLoading ? "上传中" : "上传"
              }}<i v-if="!fileLoading" class="el-icon-upload el-icon--right"></i
            ></el-button>
          </el-form-item>
        </el-row>
        <el-table :data="attachtableData" border style="width: 100%">
          <el-table-column prop="fileName" label="附件名" width="180">
            <template slot-scope="scope">
              <el-button
                @click="
                  DownloadAttachBtn(scope.row.fileUrl, scope.row.fileName)
                "
                type="text"
                size="small"
                >{{ scope.row.fileName }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="sourceTypeDesc" label="附件类型" width="180">
          </el-table-column>
          <el-table-column prop="createUser" label="上传人"> </el-table-column>

          <el-table-column prop="createTimeDesc" label="上传时间">
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="140">
            <template slot-scope="scope">
              <el-button
                @click="
                  deleteAttach(scope.row.uploadFileInfoID, scope.row.sourceType)
                "
                type="text"
                size="small"
                v-if="
                  $hasRight(
                    buttonList,
                    'Outbound:ReadyforTask:deleteTaskAttach'
                  )
                "
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-dialog>

    <!-- v-if="$hasRight(buttonList,'Outbound:ReadyforTask:deleteTaskAttach')" -->

    <!-- 打印拣货单 -->
    <el-dialog
      :visible.sync="printPickListVisible"
      v-model="printPickListVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="打印拣货单"
      width="60%"
      style="text-align: center"
    >
      <div class="print">
        <el-button type="success" v-print="printObj">打印</el-button>
      </div>
      <div id="printMe" style="height: 100%">
        <div>
          <el-row type="flex" class="row-bg">
            <el-col :span="8"
              ><div class="grid-content bg-purple">
                <strong>备货单号:{{ this.pickStockingNo }}</strong>
              </div></el-col
            >
            <el-col :span="8"
              ><div class="grid-content bg-purple">
                <strong>箱数：{{ this.pickBoxNo }}</strong>
              </div></el-col
            >
            <el-col :span="8"
              ><div class="grid-content bg-purple">
                <strong>运输方式：{{ this.pickTransportType }}</strong>
              </div></el-col
            >
          </el-row>
        </div>

        <el-table
          :data="printPickdata"
          highlight-current-row
          border
          style="width: 80%;heiht"
        >
          <el-table-column prop="stockingNo" label="备货单号" width="200">
          </el-table-column>
          <el-table-column prop="transportType" label="运输方式" width="140">
          </el-table-column>
          <el-table-column prop="warehouseName" label="仓库" width="140">
          </el-table-column>
          <el-table-column prop="locationCode" label="库位" width="140">
          </el-table-column>
          <el-table-column prop="wmsBoxNo" label="箱号【WMS箱唛】">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 添加备货任务 -->
    <el-dialog
      id="completeDialog"
      :title="addTaskTitle"
      :visible.sync="addTaskdialogVisible"
      width="90%"
      top="70px"
      style="text-align: center"
    >
      <div id="completeDiv">
        <iframe
          :src="completeTask"
          height="700"
          width="100%"
          style="border: none"
        ></iframe>
      </div>
    </el-dialog>
    <!-- 整票打印 -->
    <el-dialog
      :visible.sync="fullBoxPrintVisible"
      v-model="fullBoxPrintVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="整票打印"
      width="40%"
      style="text-align: center"
    >
      <div id="fullprint">
        <div style="text-align: center">
          <el-button type="success" plain disabled>
            货柜号：{{ selectcontainerNo }}</el-button
          >
        </div>
        <div>
          <el-row type="flex" class="row-bg">
            <el-col :span="4"
              ><div class="grid-content bg-purple">
                <strong>第三方箱唛</strong>
              </div></el-col
            >
            <el-col :span="8"
              ><div class="grid-content bg-purple">
                <el-button
                  type="info"
                  plain
                  v-if="fullBoxMarkID > 0"
                  @click="Conformfullprint(fullBoxMarkID)"
                  >直接打印</el-button
                >
                <el-button
                  type="warning"
                  plain
                  v-if="fullBoxMarkID <= 0"
                  disabled
                  >请上传文件</el-button
                >
              </div></el-col
            >
          </el-row>
          <el-row type="flex" class="row-bg">
            <el-col :span="4"
              ><div class="grid-content bg-purple">
                <strong>物流面单</strong>
              </div></el-col
            >
            <el-col :span="8"
              ><div class="grid-content bg-purple">
                <el-button
                  type="info"
                  plain
                  v-if="fulllogisticsFaceID > 0"
                  @click="Conformfullprint(fulllogisticsFaceID)"
                  >直接打印</el-button
                >
                <el-button
                  type="warning"
                  plain
                  v-if="fulllogisticsFaceID <= 0"
                  disabled
                  >请上传文件</el-button
                >
              </div></el-col
            >
          </el-row>
        </div>
      </div>
    </el-dialog>

    <!-- 按箱打印 -->
    <el-dialog
      :visible.sync="BoxPrintVisible"
      v-model="BoxPrintVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="扫描按箱打印"
      width="40%"
      style="text-align: center"
    >
      <div id="fullprint">
        <div style="text-align: center">
          <el-button type="success" plain disabled>
            货柜号：{{ selectcontainerNo }}</el-button
          >
        </div>
        <div>
          <el-row type="flex" class="row-bg">
            <el-col :span="8"
              ><div class="grid-content bg-purple">
                <el-checkbox v-model="checked" disabled>第三方箱唛</el-checkbox>
              </div></el-col
            >
          </el-row>
          <el-row type="flex" class="row-bg">
            <el-col :span="12"
              ><div class="grid-content bg-purple">
                <el-input
                  placeholder="请扫描第三方箱唛或者WMS箱唛"
                  v-model="scanLogisticsBoxNo"
                  clearable
                  @keyup.enter.native="ScanBoxCode"
                >
                </el-input></div
            ></el-col>
            <el-col :span="4"
              ><div class="grid-content bg-purple boxprint">
                <el-checkbox v-model="autoPrintChecked"
                  >识别自动打印</el-checkbox
                >
              </div></el-col
            >
          </el-row>

          <el-row type="flex" class="row-bg grid-content bg-purple">
            <el-col :span="3"> 扫描箱唛:</el-col>
            <el-col :span="8">{{ temporaryscanLogisticsBoxNo }}</el-col>
          </el-row>
          <el-row type="flex" class="row-bg grid-content bg-purple">
            <el-col :span="3">第三方箱唛:</el-col>
            <el-col :span="8">{{ DestinationBoxNo }}</el-col>
          </el-row>

          <el-row type="flex" class="row-bg grid-content bg-purple">
            <el-col :span="20">
              <el-button
                type="success"
                plain
                v-if="IsMatch"
                @click="automaticprint(stockingBoxListID)"
                >自动打印</el-button
              >

              <el-button type="info" plain v-if="!IsMatch">自动打印</el-button>

              <el-button
                type="success"
                plain
                v-if="IsMatch"
                @click="ManualPrintSplitPdf(stockingBoxListID)"
                >手动打印
              </el-button>

              <el-button type="info" plain v-if="!IsMatch">手动打印 </el-button>
            </el-col>
          </el-row>

          <el-row type="flex" class="row-bg grid-content bg-purple">
            <el-col :span="24">
              <!-- <div class="block">
            <span class="demonstration">预览</span>
            <el-image :src="src"></el-image>
          </div> -->
              <pdf :src="pdfUrl"></pdf>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";

import {
  getStockingTaskAsync,
  exportStockingTaskOut,
  getReadyforTaskDetailAsync,
  getReadyforTaskBasis,
  exportReadyforTaskPackagingOut,
  importReadyforTaskPackaging,
  getReadyforTaskReviewImages,
  importReadyforTaskReviewImages,
  getStockingTransferImages,
  editStockingTransferImages,
  PrintPickList,
  AttachFileUploadURL,
  CheckAttachFileUploadIsExist,
  GetAttachFileList,
  DownloadTaskAttach,
  DeleteTaskAttach,
  examineReadyforTaskStatus,
  PreviewsTaskAttachPDF,
  PreviewsTaskSplitPDF,
  getUploadFileInfoByStockingTaskID,
  GetPCPrintPdfUrl,
  CheckIsExamineTask,
  CheckShipIsOver,
  UpdateTaskStatusBoxLabel,
  printLog,
  downPdfFile,
} from "@/api/outbound/readyforTask.js";
import { SynchroPackDataToBaiYi } from "@/api/outbound/shippingPlan.js";
import { DownloadProductSKUAttach } from "@/api/ProductSku.js";
import { GetStockingTaskAttachList } from "@/api/common/common.js";
import axios from "axios";
import LogDialog from "../../components/TwTable/components/logDialog";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { thereAre } from "util/util";
import pdf from "vue-pdf";
import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory.js";
import { judgePlanRelationStatus } from "@/api/outbound/loadingOrder.js";
import {getOperatorInfo} from "@/api/api.js";
export default {
  components: { LogDialog, TwTable, pdf, CMapReaderFactory },
  mixins: [TwTable_mixins],
  data() {
    return {
      userList: [],
      printObj: {
        id: "printMe",
        popTitle: "拣货单",
        extraCss: "https://www.google.com,https://www.google.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          options: [
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "stockingNo",
            label: "单号信息",
            align: "left",
            sortable: true,
            minWidth: "195",
            slot: true,
          },
          {
            label: "参考信息",
            minWidth: "250",
            align: "left",
            slot: true,
            prop: "containerNo",
          },
          {
            label: "集拼柜号",
            minWidth: "150",
            prop: "jpContainerNo",
          },
          {
            prop: "transportType",
            label: "运输方式",
            minWidth: "110",
            align: "left",
            formatter: function (val, row) {
              return (
                "<span>运输方式:" +
                (row.transportType || "") +
                "</span><br /><span>物流方式: " +
                (row.channelName || "") +
                "</span><br />"
              );
            },
          },

          {
            prop: "warehouseName",
            label: "发货仓",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "stockingStatusText",
            label: "状态信息",
            align: "left",
            sortable: false,
            minWidth: "160",
            formatter: function (val, row) {
              return (
                "<span>备货: " +
                (row.stockingStatusText || "") +
                "</span><br /><span>装箱: " +
                (row.packingStatusText || "") +
                "</span><br /> <span>装车: " +
                (row.loadingTypeText || "") +
                "</span><br />"
              );
            },
          },

          {
            label: "转运信息",
            minWidth: "200",
            align: "left",
            formatter: function (val, row) {
              return (
                "<span>预约时间:" +
                (row.deliveryDate || "") +
                "</span><br /><span>车牌号: " +
                (row.carNumber || "") +
                "</span><br /> <span>司机:" +
                (row.driver || "") +
                "</span><br /> <span>电话:" +
                (row.driverPhone || "") +
                "</span><br />"
              );
            },
          },

          {
            label: "打包数量",
            minWidth: "140",
            align: "left",
            formatter: function (val, row) {
              return (
                "<span>数量:" +
                (row.totalBoxQty || "") +
                "</span><br /><span>体积:" +
                (row.totalVolume + "" || "") +
                "cbm" +
                "</span><br /><span>毛重:" +
                (row.totalWeight + "" || "") +
                "kg" +
                "</span><br />"
              );
            },
          },
          {
            prop: "file",
            label: "附件",
            align: "left",
            slot: true,
            minWidth: "145",
          },
          {
            prop: "operatorInfo",
            label: "操作人",
            slot: true,
            minWidth: "100",
          },
          {
            label: "操作节点",
            minWidth: "220",
            align: "left",
            formatter: function (val, row) {
              return (
                "<span>推送时间:" +
                row.createTime +
                "</span><br /><span>拣货时间:" +
                (row.pickTime || "") +
                "</span><br /> <span>打包时间:" +
                (row.packTime || "") +
                "</span><br /><span>开始装车:" +
                (row.loadTime || "") +
                "</span><br /><span>出库时间:" +
                (row.outTime || "") +
                "</span><br />"
              );
            },
          },
          {
            prop: "serviceInformation",
            label: "服务信息",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
        ],
      },
      UploadFileInfo: {},
      attachFormVisible: false,
      attachForm: {},
      pickStockingNo: "",
      pickBoxNo: 0,
      pickTransportType: "",
      printPickListVisible: false,
      fullBoxPrintVisible: false,
      BoxPrintVisible: false,
      searchData: {
        //搜索列配置
        search: [
          {
            type: "input",
            key: "stockingNo",
            label: "备货单号",
            placeholder: "请输入备货单号",
            clearable: true,
          },
          {
            type: "input",
            key: "containerNumber",
            label: "货柜号",
            placeholder: "请输入货柜号",
            clearable: true,
          },
          {
            type: "input",
            key: "stockTransferNo",
            label: "调拨单号",
            placeholder: "请输入调拨单号",
            clearable: true,
          },

          {
            type: "input",
            key: "sku",
            label: "SKU",
            placeholder: "请输入SKU",
            clearable: true,
          },
        ],
        ///高级搜索配置
        moreSearch: [
          {
            type: "select",
            key: "status",
            prop: "status",
            label: "状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.statuslist,
          },
          {
            type: "select",
            key: "dataSourceType",
            prop: "dataSourceType",
            label: "数据来源",
            multiple: true,
            slot: true,
            placeholder: "请选择数据来源",
            option: this.dataSourceTypeList,
          },
          {
            type: "select",
            key: "transport",
            prop: "transport",
            label: "运输方式",
            multiple: true,
            slot: true,
            placeholder: "请选择运输方式",
            option: this.transportList,
          },
          {
            type: "select",
            key: "packingStatus",
            prop: "packingStatus",
            label: "装箱状态",
            multiple: true,
            slot: true,
            placeholder: "请选择装箱状态",
            option: this.packingStatusList,
          },
          {
            type: "select",
            key: "loadingType",
            prop: "loadingType",
            label: "装车状态",
            multiple: true,
            slot: true,
            placeholder: "请选择装车状态",
            option: this.loadingTypeList,
          },

          {
            type: "select",
            key: "wareHouse",
            prop: "wareHouse",
            label: "发货仓",
            multiple: true,
            slot: true,
            placeholder: "请选择发货仓",
            option: this.warehouseList,
          },
          {
            type: "input",
            key: "inStockSKUCode",
            label: "调入仓SKU",
            placeholder: "请输入调入仓SKU",
            clearable: true,
          },
          {
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
          },
        ],
      },
      multipleAttach: false,
      acceptAttach: ".pdf",
      buttonList: [],
      skuForm: [],
      editFormVisible: false,
      editLoading: false,
      transportList: [],
      dataSourceTypeList: [],
      boxtabledata: [],
      fullBoxMarkID: 0,
      fulllogisticsFaceID: 0,
      validation: true,
      statuslist: [],
      warehouseList: [],
      DetailForm: {},
      visibledialogDetail: false,
      plantabledata: [],
      dialogVisible: false, //隐藏图片展示框
      progressFlag: false, //进度条初始值隐藏
      progressPercent: 0, //进度条初始值
      Importtext: "", //导入返回信息
      importVisible: false,
      srcList: [],
      boxMarkVisible: false,
      transferdata: [],
      printPickdata: [],
      packingStatusList: [],
      rowColumn: {},
      parafile: "", //临时存储上传装箱文件
      type: 1, //1询问是否取消重新导入 2直接导入
      fileList: [],
      fileListAttach: [],
      limitAttach: 1,
      importPicture: false,
      options_attachType: [],
      attachtableData: [],
      Importtext: "", //导入返回信息
      progressFlag: false, //进度条初始值隐藏
      progressPercent: 0, //进度条初始值
      completeTask: "",
      addTaskTitle: "",
      addTaskdialogVisible: false,
      selectcontainerNo: "",
      checked: true,
      autoPrintChecked: false,
      scanLogisticsBoxNo: "",
      temporaryscanLogisticsBoxNo: "",
      DestinationBoxNo: "",
      IsMatch: false,
      stockingBoxListID: 0,
      src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      pdfUrl: "",
      tempBlob: "",
      printSuccess: false,
      fileLoading: false,
      loadingTypeList: [],
      afileData: [],
    };
  },
  created() {
    // 监听子组件的关闭事件
    window.addEventListener(
      "message",
      () => {
        this.closeSelf();
      },
      false
    );
  },
  methods: {
    resetBtn() {
      this.filters = {};
    },
    //打印箱唛文件
    printMark(stockingTaskID, Imgurl) {
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      printLog({
        sourceID: stockingTaskID,
        type: "PCStockingTask",
      }).then((res) => {
        if (res.data.success) {
          // 下载pdf
          function convertBase64ToBlob(base64, fileType, slice) {
            return new Blob(
              atob(base64)
                .match(
                  new RegExp(`([\\s\\S]{${slice}})|([\\s\\S]{1,${slice}})`, "g")
                )
                .map(function (item) {
                  return new Uint8Array(
                    item.split("").map(function (s, i) {
                      return item.charCodeAt(i);
                    })
                  );
                }),
              { type: fileType }
            );
          }
          const blob = convertBase64ToBlob(Imgurl, "application/pdf", 1024);
          if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(blob, "箱唛文件.pdf");
          }
          const urlFromBlob = window.URL.createObjectURL(blob);
          window.open(urlFromBlob);
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        loading.close();
      });
    },
    // 弹出添加装车单
    addLoadCardialog() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "至少选择一行数据！",
          type: "error",
        });
        return;
      }
      let orgId = row[0].orgID;
      let transportType = row[0].transportType;

      let orgIdArr = row.filter((m) => {
        return m.orgID === orgId;
      });

      if (row.length != orgIdArr.length) {
        this.$message({
          message: "请选择同一客户备货任务",
          type: "error",
        });
        return;
      }
      let transportTypeArr = row.filter((m) => {
        return m.transportType === transportType;
      });
      if (row.length != transportTypeArr.length) {
        this.$message({
          message: "请选择同一运输方式备货任务",
          type: "error",
        });
        return;
      }

      let stockingStatusArr = row.filter((m) => {
        return (
          m.stockingStatus === 1 ||
          m.stockingStatus === 5 ||
          m.stockingStatus === 30 ||
          m.stockingStatus === 99
        );
      });
      if (stockingStatusArr.length > 0) {
        this.$message({
          message: "请选择状态是【待备货】【备货中】的备货任务",
          type: "error",
        });
        return;
      }
      let stockingTaskIDS = row.map((item) => item.stockingTaskID).join(",");
      judgePlanRelationStatus({
        stockingTaskIDS: stockingTaskIDS,
      }).then((res) => {
        if (res.data.success) {
          var random = Math.random();
          this.addTaskTitle = "装车单";
          this.completeTask =
            "/Outbound/AddLoadingOrder?random=" +
            random +
            "&stockingTaskIDS=" +
            stockingTaskIDS +
            "&orgId=" +
            orgId +
            "&transportType=" +
            transportType +
            "";
          this.addTaskdialogVisible = true;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 弹出添加备货任务
    addTaskdialog() {
      this.addTaskTitle = "备货任务";
      this.completeTask = "/Outbound/AddReadyforTask";
      this.addTaskdialogVisible = true;
    },
    handleClose(done) {
      this.$refs.refupload.clearFiles();
      this.attachFormVisible = false;
      this.initTable();
    },
    closeSelf() {
      // 关闭当前弹框
      this.addTaskdialogVisible = false;
      this.initTable();
    },
    closeAttachDialog() {
      console.log("是否关闭");
      this.initTable();
    },
    // 弹出修改任务
    editTaskdialog() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].dataSourceType == 1) {
        this.$message({
          message: "请选择数据来源是【手动单据】的数据！",
          type: "error",
        });

        return;
      }
      if (this.selectRows.rows[0].stockingStatus != 1) {
        this.$message({
          message: "只能修改状态是【待审核】的数据！",
          type: "error",
        });
        return;
      }
      console.log(row);
      this.addTaskTitle = "备货任务";
      var random = Math.random();
      this.completeTask =
        "/Outbound/AddReadyforTask?random=" +
        random +
        "&stockingTaskID=" +
        row[0].stockingTaskID;
      this.addTaskdialogVisible = true;
    },
    //审核备货任务
    examineStatus() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].dataSourceType == 1) {
        this.$message({
          message: "请选择数据来源是【手动单据】的数据！",
          type: "error",
        });

        return;
      }
      if (this.selectRows.rows[0].stockingStatus != 1) {
        this.$message({
          message: "请选择状态是【待审核】的数据！",
          type: "error",
        });
        return;
      }
      this.$confirm(
        "确认要审核备货任务" + row[0].stockingNo + "吗？",
        "提示",
        {}
      ).then(() => {
        examineReadyforTaskStatus({
          stockingTaskId: row[0].stockingTaskID,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "审核成功",
              type: "success",
            });
            this.initTable();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    //下载WMS箱唛
    //打印仓库箱唛
    downloadBoxMark() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].dataSourceType != 1) {
        this.$message({
          message: "请选择数据来源是【API】的数据！",
          type: "error",
        });

        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      getUploadFileInfoByStockingTaskID({
        stockingTaskId: row[0].stockingTaskID,
      }).then((res) => {
        loading.close();
        if (res.data.success) {
          window.open(res.data.response.fileUrl, "_blank");
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },

    printPickList() {
      const that = this;
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].dataSourceType == 1) {
        this.$message({
          message: "请选择数据来源是【手动单据】的数据！",
          type: "error",
        });

        return;
      }

      this.printPickListVisible = true;

      PrintPickList({ StockingTaskId: row[0].stockingTaskID }).then((res) => {
        this.printPickdata = res.response;
        if (res.response) {
          that.pickStockingNo = res.response[0].stockingNo;
          that.pickBoxNo = res.response.length;
          that.pickTransportType = res.response[0].transportType;
        }
      });
    },
    OpenAttach() {
      const that = this;
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }

      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].dataSourceType == 1) {
        this.$message({
          message: "请选择数据来源是【手动单据】的数据！",
          type: "error",
        });

        return;
      }
      this.attachForm = {};

      GetStockingTaskAttachList({}).then((res) => {
        this.options_attachType = res.data.response;
      });
      this.attachFormVisible = true;

      this.initAttachTable();
    },

    Conformfullprint(UploadFileInfoID) {
      const loading = this.$loading({
        lock: true,
        text: "打印中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      PreviewsTaskAttachPDF({ uploadFileInfoId: UploadFileInfoID }).then(
        (res) => {
          loading.close();
          if (res.data.status === 200 && res.data.success) {
            let { fileName, fileData } = res.data.response;

            // 下载pdf
            function convertBase64ToBlob(base64, fileType, slice) {
              return new Blob(
                atob(base64)
                  .match(
                    new RegExp(
                      `([\\s\\S]{${slice}})|([\\s\\S]{1,${slice}})`,
                      "g"
                    )
                  )
                  .map(function (item) {
                    return new Uint8Array(
                      item.split("").map(function (s, i) {
                        return item.charCodeAt(i);
                      })
                    );
                  }),
                { type: fileType }
              );
            }

            const blob = convertBase64ToBlob(fileData, "application/pdf", 1024);
            if (navigator.msSaveBlob) {
              return navigator.msSaveBlob(blob, fileName);
            }
            const urlFromBlob = window.URL.createObjectURL(blob);
            window.open(urlFromBlob);

            // const a = document.createElement('a');
            // a.style.display = 'none';
            // a.href = urlFromBlob;
            // // a.download = fileName;
            // document.body.appendChild(a);
            // a.setAttribute('target','_blank')
            // a.click();
            // window.URL.revokeObjectURL(urlFromBlob);
            // document.body.removeChild(a)
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        }
      );

      var para = { StockingTaskID: this.selectRows.rows[0].stockingTaskID };
      UpdateTaskStatusBoxLabel(para).then((res) => {
        console.log(res.msg);
      });
    },

    ManualPrintSplitPdf(stockingBoxListID) {
      const urlFromBlob = window.URL.createObjectURL(this.tempBlob);
      window.open(urlFromBlob);

      UpdateTaskStatusBoxLabel({
        StockingTaskID: this.selectRows.rows[0].stockingTaskID,
      }).then((res) => {
        console.log(res.msg);
      });
    },
    automaticprint(stockingBoxListID) {
      if (stockingBoxListID <= 0) {
        this.$message({
          message: "文件不存在！",
          type: "error",
        });
        return;
      }
      var para = { stockingBoxListID: stockingBoxListID };
      GetPCPrintPdfUrl(para).then((res) => {
        if (!res.success) {
          this.$message({
            message: res.msg,
            type: "error",
          });
          return;
        } else {
          this.jsonpPrint(res.response);
        }
      });

      UpdateTaskStatusBoxLabel({
        StockingTaskID: this.selectRows.rows[0].stockingTaskID,
      }).then((res) => {
        console.log(res.msg);
      });
    },

    jsonpPrint(url) {
      let ipaddress = "http://localhost:3456";

      url = ipaddress + url;

      console.log(url);

      const loading = this.$loading({
        lock: true,
        text: "打印中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      this.printSuccess = false;
      this.$http
        .jsonp(url)
        .then((res) => {
          console.log("success", res.body.s); //请求成功
          loading.close();
        })
        .catch((err) => {
          console.log("err", err); //请求失败
          loading.close();
          if (err.status === 0) {
            // 更新状态    打印机有时会跑到err事件里,暂时这样处理
            this.printSuccess = true;
          } else {
            this.$message({
              message: "打印失败",
              type: "error",
            });
            return;
          }
        });
    },
    fullBoxPrint() {
      const that = this;
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].dataSourceType == 1) {
        this.$message({
          message: "请选择数据来源是【手动单据】的数据！",
          type: "error",
        });

        return;
      }

      CheckIsExamineTask({
        StockingTaskID: this.selectRows.rows[0].stockingTaskID,
      }).then((res) => {
        if (!res.success) {
          this.$message({
            message: res.msg,
            type: "error",
          });

          return;
        } else {
          const loading = that.$loading({
            lock: true,
            text: "打印文件加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.5)",
          });
          this.selectcontainerNo = this.selectRows.rows[0].containerNo;
          this.fullBoxPrintVisible = true;
          that.fullBoxMarkID = 0;
          that.fulllogisticsFaceID = 0;
          GetAttachFileList({
            StockingTaskId: this.selectRows.rows[0].stockingTaskID,
          }).then((res) => {
            loading.close();
            var result = res.response;
            if (result) {
              var fullBoxMarkdata = result.filter(
                (item) => item.sourceType == 23
              );
              console.log(fullBoxMarkdata);
              if (fullBoxMarkdata.length > 0) {
                that.fullBoxMarkID = fullBoxMarkdata[0].uploadFileInfoID;
              }
              var fulllogisticsFaceData = result.filter(
                (item) => item.sourceType == 24
              );

              if (fulllogisticsFaceData.length > 0) {
                that.fulllogisticsFaceID =
                  fulllogisticsFaceData[0].uploadFileInfoID;
              }
            }
          });
        }
      });
    },

    pressBoxPrint() {
      const that = this;
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].dataSourceType == 1) {
        this.$message({
          message: "请选择数据来源是【手动单据】的数据！",
          type: "error",
        });

        return;
      }

      CheckIsExamineTask({
        StockingTaskID: this.selectRows.rows[0].stockingTaskID,
      }).then((res) => {
        if (!res.success) {
          this.$message({
            message: res.msg,
            type: "error",
          });

          return;
        } else {
          that.pdfUrl = "";
          that.selectcontainerNo = "";
          that.scanLogisticsBoxNo = "";
          that.DestinationBoxNo = "";
          that.temporaryscanLogisticsBoxNo = "";
          that.selectcontainerNo = that.selectRows.rows[0].containerNo;
          that.IsMatch = false;
          that.BoxPrintVisible = true;
        }
      });
    },

    ScanBoxCode() {
      const that = this;
      that.IsMatch = false;
      let temporarystorage = that.scanLogisticsBoxNo;
      that.temporaryscanLogisticsBoxNo = temporarystorage;

      PreviewsTaskSplitPDF({
        StockingTaskID: this.selectRows.rows[0].stockingTaskID,
        ScanCode: this.scanLogisticsBoxNo,
      }).then((res) => {
        if (res.status === 200 && res.success) {
          that.DestinationBoxNo = res.msg;
          that.IsMatch = true;
          let { fileName, fileData, fileId } = res.response;

          that.stockingBoxListID = fileId;

          if (that.autoPrintChecked == true) {
            that.automaticprint(fileId);
          }

          // 下载pdf
          function convertBase64ToBlob(base64, fileType, slice) {
            return new Blob(
              atob(base64)
                .match(
                  new RegExp(`([\\s\\S]{${slice}})|([\\s\\S]{1,${slice}})`, "g")
                )
                .map(function (item) {
                  return new Uint8Array(
                    item.split("").map(function (s, i) {
                      return item.charCodeAt(i);
                    })
                  );
                }),
              { type: fileType }
            );
          }

          const blob = convertBase64ToBlob(fileData, "application/pdf", 1024);
          if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(blob, fileName);
          }

          that.tempBlob = blob;

          //this.pdfUrl = pdf.createLoadingTask({ url: window.URL.createObjectURL(blob), CMapReaderFactory })

          that.pdfUrl = pdf.createLoadingTask({
            url: window.URL.createObjectURL(blob),
            cMapUrl: "../../../../static/cmaps/",
            cMapPacked: true,
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          this.return;
        }

        that.scanLogisticsBoxNo = "";
      });
    },
    DownloadAttachBtn(url, filename) {
      DownloadTaskAttach(url, filename);
    },
    deleteAttach(uploadFileInfoID, type) {
      this.$confirm("确认删除附件?", "提示", {
        type: "warning",
      }).then(() => {
        if (uploadFileInfoID == null || uploadFileInfoID == "") {
          this.$message({
            message: "删除失败,该附件不存在！",
            type: "error",
          });
        } else {
          const loading = this.$loading({
            lock: true,
            text: "删除中,请稍等...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.5)",
          });
          var para = {
            uploadFileInfoID: uploadFileInfoID,
            StockingTaskID: this.selectRows.rows[0].stockingTaskID,
            type: type,
          };
          DeleteTaskAttach(para).then((res) => {
            loading.close();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.initAttachTable();
            } else {
              this.$message({
                message: "删除失败" + res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    //弹出导入文件框
    importExport() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      CheckShipIsOver({
        StockingTaskID: this.selectRows.rows[0].stockingTaskID,
      }).then((res) => {
        if (!res.success) {
          this.$message({
            message: res.msg,
            type: "error",
          });
          return;
        } else {
          this.Importtext = "";
          this.importVisible = true;
          this.type = 1;
        }
      });
    },
    //点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.rowColumn = row;
      console.log(this.rowColumn);
    },

    //下载打包数据
    handleDownload() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].dataSourceType != 1) {
        this.$message({
          message: "请选择数据来源是【API】的数据！",
          type: "error",
        });
        return;
      }
      if (
        row[0].stockingStatus == 30 ||
        row[0].stockingStatus == 99 ||
        row[0].stockingStatus == 5
      ) {
        this.$message({
          message: "仅可对状态为【打包中】和【已打包】的数据进行操作",
          type: "error",
        });
        return;
      }
      let pata = { stockingTaskID: row[0].stockingTaskID };

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(exportReadyforTaskPackagingOut, {
          params: pata,
        })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    httpRequest(param) {
      // this.fileList.push(param.file)
      console.log(param);
    },
    //移除图片
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    onRemove(file, fileList) {
      this.fileList = fileList;
    },
    onAttachRemove(file, fileList) {
      this.fileListAttach = fileList;
      this.afileData = fileList;
    },
    addReadyImages() {
      this.fileList = [];
      this.importPicture = true;
    },
    //箱唛文件上传前验证
    onBeforeUploadBoxMarkExcel(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: "上传文件不能大于10M，请选择小的文件",
          type: "error",
        });
        return false; //必须返回false
      }
    },

    auploadFile(param) {
      console.log("1");
      console.log(param);
      this.afileData.push(param.file);
      console.log(this.afileData);
    },
    UploadAttachConfirm() {
      this.fileLoading = true;
      const loading = this.$loading({
        lock: true,
        text: "上传中,请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      let para = new FormData();

      this.afileData.forEach((i, index) => {
        para.append("files", i.raw);
      });

      para.append("StockingTaskID", this.selectRows.rows[0].stockingTaskID);

      para.append("StockingTaskAttachType", this.attachForm.attachType);
      this.progressFlag = true;
      var _this = this;

      axios({
        url: AttachFileUploadURL,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          // progressEvent.loaded:已上传文件大小
          // progressEvent.total:被上传文件的总大小
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          this.fileLoading = false;
          this.Importtext = res.data.msg;
          loading.close();
          console.log(res.data);
          console.log(this.Importtext);
          if (res.data.success) {
            console.log("导入成功");
            // param.onError(); // 上传成功的文件会显示绿色的对勾
            this.importVisible = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.$refs.refupload.clearFiles();
            this.fileListAttach = [];
            this.afileData = [];
            this.initAttachTable();
          } else {
            this.$message({
              message: res.data.msg + "请修改数据重新导入",
              type: "error",
            });
            this.$refs.refupload.clearFiles();
            this.fileListAttach = [];
            this.afileData = [];
            //param.onError();
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          this.$refs.refupload.clearFiles();
          this.fileListAttach = [];
          this.afileData = [];
          //param.onError();
        });
    },

    initAttachTable() {
      const loading = this.$loading({
        lock: true,
        text: "列表数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      this.attachtableData = [];

      GetAttachFileList({
        StockingTaskId: this.selectRows.rows[0].stockingTaskID,
      }).then((res) => {
        loading.close();
        this.attachtableData = res.response;
      });
    },
    //上传文件
    UploadAttach() {
      if (!this.selectRows.rows[0].stockingTaskID) {
        this.$message({
          message: "数据未加载完",
          type: "error",
        });
        return false; //必须返回false
      }
      if (this.afileData.length <= 0) {
        this.$message({
          message: "请选择文件",
          type: "error",
        });
        return false; //必须返回false
      }
      var data = {
        StockingTaskAttachType: Number(this.attachForm.attachType),
        StockingTaskID: this.selectRows.rows[0].stockingTaskID,
      };

      console.log("附件类型" + this.attachForm.attachType);
      if (!this.attachForm.attachType) {
        this.$message({
          message: "请选择附件类型",
          type: "error",
        });
        return false; //必须返回false
      }

      console.log(this.fileListAttach.length);

      console.log(this.afileData.length);
      if (this.afileData.length > 8) {
        this.$message({
          message: "最多支持上传8张",
          type: "error",
        });
        return false; //必须返回false
      }

      for (var i = 0; i < this.afileData.length; i++) {
        console.log(this.afileData[i].size);
        if (
          this.attachForm.attachType == 23 ||
          this.attachForm.attachType == 24
        ) {
          console.log("是否进来了");
          if (this.afileData[i].size > 10 * 1024 * 1024) {
            this.$message({
              message:
                "文件" + this.afileData[i].name + "不能大于10M，请选择小的文件",
              type: "error",
            });
            return false; //必须返回false
          }
        } else {
          if (this.afileData[i].size > 4 * 1024 * 1024) {
            this.$message({
              message:
                "文件" + this.afileData[i].name + "不能大于4M，请选择小的文件",
              type: "error",
            });
            return false; //必须返回false
          }
        }
      }
      if (
        data.StockingTaskAttachType != 23 &&
        data.StockingTaskAttachType != 24
      ) {
        this.UploadAttachConfirm();
      } else {
        CheckAttachFileUploadIsExist(data).then((res) => {
          if (res.status <= 0) {
            this.$confirm("该附件已存在, 是否覆盖?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.UploadAttachConfirm();
              })
              .catch(() => {});
          } else {
            this.UploadAttachConfirm();
          }
        });
      }
    },
    selectAttach() {
      if (
        this.attachForm.attachType == 23 ||
        this.attachForm.attachType == 24
      ) {
        this.multipleAttach = false;
        this.acceptAttach = ".pdf";
      } else {
        this.multipleAttach = true;
        this.acceptAttach = ".jpg,.png,.jpeg,.gif";
      }
      console.log("dd" + this.acceptAttach);
    },
    //文件上传前验证
    onBeforeUpload(file) {
      if (!this.attachForm.attachType) {
        this.$message({
          message: "请选择附件类型",
          type: "error",
        });
        return false; //必须返回false
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: "上传文件不能大于10M，请选择小的文件",
          type: "error",
        });
        return false; //必须返回false
      }
    },

    onChange(file, fileList) {
      this.fileList = fileList;
      console.log(this.fileList);
    },

    onChangeAttach(file, fileList) {
      console.log("00000", fileList);
      //  this.$refs.refupload.clearFiles();

      console.log("fileListAttach0000", this.fileListAttach);
      console.log(this.fileListAttach.length);

      // if(this.fileListAttach.length>0){
      //    this.$message({
      //     message: `请先上传${file.name}文件`,
      //     type: "error",
      //   });
      // }else{
      this.afileData.push(file);
      this.fileListAttach = fileList;

      //}

      console.log("fileListAttach1111", this.fileListAttach);
    },
    handleExceedAttach(files, fileList) {
      if (this.multipleAttach == false) {
        this.limitAttach = 1;
      } else {
        this.limitAttach = 20;
      }
    },

    //上传箱唛文件
    UploadBoxMarkExcel(file) {
      var row = this.rowColumn;

      let para = new FormData();
      for (var i = 0; i < this.fileList.length; i++) {
        console.log(this.fileList[i].size);
        if (this.fileList[i].size > 10 * 1024 * 1024) {
          this.$message({
            message:
              "文件" + this.fileList[i].name + "不能大于10M，请选择小的文件",
            type: "error",
          });
          return false; //必须返回false
        }
        para.append("file", this.fileList[i].raw); //此处一定是append file.raw 上传文件只需维护fileList file.raw.name要加上
        para.append("fileName", this.fileList[i].name);
      }

      console.log(this.fileList);
      //para.append("file", param.file);
      this.progressFlag = true;
      axios({
        url:
          editStockingTransferImages +
          "?stockingTaskID=" +
          row.stockingTaskID +
          "&&stockingTransferID=" +
          row.stockingTransferID +
          "",
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.importPicture = false;
            //param.onError(); // 上传成功的文件会显示绿色的对勾

            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getBoxMarkTransfer(row.stockingTaskID);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
            //param.onError();
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          //param.onError();
        });
    },
    //下载箱唛文件
    DownloadProductSKUAttachBtn(imgurls) {
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      imgurls.forEach((file) => {
        console.log(file.url);
        if (file.uploadType === 1) {
          DownloadProductSKUAttach(file.fileUrl, file.fileUrl);
        }
        if (file.uploadType === 2) {
          const data = {
            fielUrl: file.fileUrl,
          };
          axios
            .get(downPdfFile, {
              params: data,
            })
            .then((res) => {
              console.log(res);
              if (res.data.success) {
                var data = res.data;
                var arr = data.msg.split(",");
                var mime = arr[0].match(/:(.*?);/)[1];
                var bstr = atob(arr[1]);
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while (n--) {
                  u8arr[n] = bstr.charCodeAt(n);
                }
                var blob = new Blob([u8arr], { type: mime });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                let fileName =
                  file.fileName === ""
                    ? ""
                    : file.fileName.indexOf(".pdf") > -1
                    ? file.fileName
                    : file.fileName + ".pdf";
                a.download = decodeURIComponent(fileName);
                a.click();
                window.URL.revokeObjectURL(url);
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
      loading.close();
    },

    //文件上传前验证
    onBeforeUploadExcel(file) {
      console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: "导入文件只能是 xls、xlsx格式!",
          type: "error",
        });
      }
      return extension || extension2;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    //上传文件
    UploadExcel(param) {
      if (param == undefined) {
        this.$message({
          message: "请上传导入文件",
          type: "error",
        });
        return;
      }
      console.log(param, "文件");
      this.parafile = param;
      let para = new FormData();
      para.append("file", param.file);
      this.progressFlag = true;
      axios({
        url: importReadyforTaskPackaging + "?type=" + this.type,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          this.type = 1;
          this.Importtext = res.data.msg;
          console.log(this.Importtext);
          if (res.data.success) {
            if (res.data.msg === "上传成功") {
              this.parafile = "";
              param.onError(); // 上传成功的文件会显示绿色的对勾
              this.importVisible = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.initTable();
            } else {
              this.$alert(res.data.msg, {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.parafile = "";
                  param.onError(); // 上传成功的文件会显示绿色的对勾
                  this.importVisible = false;
                  this.initTable();
                },
              });
            }
          } else {
            if (res.data.status == 300) {
              this.$confirm(res.data.msg, "提示", {}).then(() => {
                this.type = 2;
                this.UploadExcel(this.parafile);
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
              param.onError();
            }
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          param.onError();
        });
    },

    //显示详情
    addBoxMark(stockingTaskID) {
      let pata = { stockingTaskID };
      this.DetailForm = {};
      this.boxtabledata = [];
      this.plantabledata = [];
      this.visibledialogDetail = true;
      getReadyforTaskDetailAsync(pata).then((res) => {
        if (res.data.success) {
          this.DetailForm = Object.assign({}, res.data.response.taskDetail);
          this.boxtabledata = res.data.response.stockingBoxDetail;
          this.plantabledata = res.data.response.shippingPlanDetail;
        } else {
          this.$message({
            message: "备货单明细查询失败",
            type: "error",
          });
        }
      });
    },
    getBoxMarkTransfer(stockingTaskID) {
      let pata = { stockingTaskID };
      this.transferdata = [];
      this.boxMarkVisible = true;
      getStockingTransferImages(pata).then((res) => {
        if (res.data.success) {
          this.transferdata = res.data.response;
        } else {
          this.$message({
            message: "调拨单明细查询失败",
            type: "error",
          });
        }
      });
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },

    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    //查询
    initTable() {
      const {
        stockingNo,
        containerNumber,
        stockTransferNo,
        status,
        wareHouse,
        transport,
        sku,
        inStockSKUCode,
        packingStatus,
        dataSourceType,
        loadingType,
        realName,
      } = this.newfilters;
      console.log(this.newfilters);
      let pata = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        stockingNo,
        containerNumber,
        stockTransferNo,
        status: thereAre(status),
        wareHouse: thereAre(wareHouse),
        transport: thereAre(transport),
        packingStatus: thereAre(packingStatus),
        realName:thereAre(realName),
        sku,
        inStockSKUCode,
        dataSourceType: thereAre(dataSourceType),
        loadingType: thereAre(loadingType),
      };

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;

      getStockingTaskAsync(pata).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;
        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;
      let stockingTaskIDs = "";
      row.forEach((item) => {
        stockingTaskIDs += item.stockingTaskID + ",";
      });

      const {
        stockingNo,
        containerNumber,
        stockTransferNo,
        status,
        wareHouse,
        transport,
        sku,
        inStockSKUCode,
        packingStatus,
        dataSourceType,
        loadingType,
      } = this.newfilters;

      let pata = {
        page: 1,
        pageSize: 60001,
        stockingNo,
        containerNumber,
        stockTransferNo,
        status: thereAre(status),
        wareHouse: thereAre(wareHouse),
        transport: thereAre(transport),
        packingStatus: thereAre(packingStatus),
        sku,
        inStockSKUCode,
        stockingTaskIDs: thereAre(stockingTaskIDs),
        dataSourceType: thereAre(dataSourceType),
        loadingType: thereAre(loadingType),
      };

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportStockingTaskOut,
        method: "post",
        data: pata,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    //预览图片
    getReadyImages(id, type) {
      const data = {
        stockingTaskID: id,
        type: type,
      };

      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getReadyforTaskReviewImages(data).then((res) => {
        console.log(res);
        loading.close();
        if (res.data.status === 200 && res.data.success) {
          const { response } = res.data;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });
          this.srcList = response;
          this.$viewer.view(0);
          this.$viewer.show();
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },
    //下载照片
    handleImages(id, type) {
      const data = {
        stockingTaskID: id,
        type: type,
      };

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(importReadyforTaskReviewImages, {
          params: data,
        })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //同步打包信息
    syncPackData() {
      let row = this.selectRows.rows;

      if (row.length <= 0) {
        this.$message({
          message: "请选择一行数据",
          type: "error",
        });
        return;
      }
      if (row.length > 1) {
        this.$message({
          message: "请选择一行数据",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].dataSourceType != 1) {
        this.$message({
          message: "请选择数据来源是【API】的数据！",
          type: "error",
        });
        return;
      }
      if (row[0].packingStatus != 99) {
        this.$message({
          message: "请选择装箱状态为：同步失败的数据",
          type: "error",
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "同步中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      SynchroPackDataToBaiYi({ StockingTaskID: row[0].stockingTaskID }).then(
        (res) => {
          loading.close();
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });

            this.initTable();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    },
    //加载基础资料
    getBasicdatalist() {
      let user = JSON.parse(window.localStorage.user);
      this.warehouseList = user.warehouseList;
      getReadyforTaskBasis("").then((res) => {
        this.transportList = res.data.response.transportdata;
        this.statuslist = res.data.response.stockingdata;
        this.packingStatusList = res.data.response.packingdata;
        this.dataSourceTypeList = res.data.response.taskDataSourceType;
        this.loadingTypeList = res.data.response.loadingTypedata;
      });
    },
  },
  mounted() {
    //查询按钮权限
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    console.info(routers);
    this.buttonList = getButtonList(this.$route.path, routers);

    this.getBasicdatalist();
     getOperatorInfo().then((res) => {
      this.userList = res.data.response;
    });
  },
};
</script>
<style scoped lang="less">
.bg-purple {
  text-align: left;
  font-weight: bold;
  margin-bottom: 10px;
}
.print {
  text-align: right;
}
.fullprint {
  width: 120px;
}
.boxprint {
  margin-top: 10px;
  margin-left: 30px;
}
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
</style>

